import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, Dispatch } from 'redux';

import { getUriQueryParameter } from '@impuls-coach/util-get-uri-query-parameter';
import AnamnesisView, { Views as ANAMNESIS_VIEWS } from 'components/organisms/Anamnesis';
import i18n from 'helper/i18n';
import { actionCreators as eventsAC } from 'store/events';
import { actionCreators, getIsAnamnesisDone, getIsUpdatingAnamnesis } from 'store/profile';
import { IRootState } from 'store/rootReducer';
import { WithRouterType } from 'types/withRouter';
import { mapParentStateToProps } from '../Anamnesis';

const mapStateToProps = (state: IRootState, props: WithRouterType) => {
	const referrer = getUriQueryParameter('referrer');
	return {
		...mapParentStateToProps(state, props),
		currentStep: ANAMNESIS_VIEWS.DSGVO,
		introTitle: i18n(`react.impulsCoach.components.anamnesis.dsgvo.introTitle`),
		introText: i18n(`react.impulsCoach.components.anamnesis.dsgvo.introText`),
		// because https://inside.namics.com/display/TAFrontend/questions/520323125/answers/520716431
		title: undefined,
		isUpdatingAnamnesis: getIsUpdatingAnamnesis(state),
		disclaimerAccepted: getIsAnamnesisDone(state),
		buttons: [
			{
				link: {
					modifier: 'button',
					title: i18n(
						`react.impulsCoach.components.anamnesis.dsgvo.${
							typeof referrer === 'string' && referrer !== '' ? 'referrerButtonText' : 'buttonText'
						}`
					),
					openInNewWindow: false,
					iconRight: 'link-arrow',
				},
			},
		],
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => {
	return bindActionCreators(
		{
			...actionCreators,
			doAddEvents: eventsAC.doAddEvents,
		},
		dispatch
	);
};

export type DsgvoContainerProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AnamnesisView) as any);
